export default __webpack_public_path__ + "static/media/Banner.06c213be.png";